module.exports = __webpack_public_path__ + "img/avalia.307cec71.png";